<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <main class="register">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png">
      <section class="reg_1">
        <h1 v-if="!hasStepsToDisplay">{{ $_getTranslations.visitor_sign_up_register_three_steps }}</h1>
        <h1 v-else>{{ $_getTranslations.visitor_sign_up_register_two_steps }}</h1>

        <read-only-stepper-header
          v-if="!hasStepsToDisplay"
          :total-steps="3"
          :active-step="2"
        ></read-only-stepper-header>

        <read-only-stepper-header
          v-else
          :total-steps="2"
          :active-step="2"
        ></read-only-stepper-header>

        <img src="/static/images/register/mobile_img.svg" class="register_mobile" alt="mobile image">

        <p>{{ $_getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>

        <base-digit-form-input
          v-model="user.pin"
          :label="$_getTranslations.visitor_sign_up_2_validation_code"
          :invalid="hasErrors && pinError"
          :max-length="maximumDigitsPinLength"
          :input-type="'password'"
          @keyup="check"
        ></base-digit-form-input>

        <div class="error_text" v-if="hasErrors && pinError">{{ $_getTranslations.visitor_sign_up_2_warning_msg_wrong_verification_code}}</div>


        <div class="remember_checkbox">
          <input id="remember_me" v-model="rememberMe" type="checkbox" checked="">
          <label for="remember_me">{{ $_getTranslations.common_remember_me }}</label>
        </div>

        <p>{{ $_getTranslations.visitor_sign_up_free_for }}</p>

        <div v-if="hasStepsToDisplay" class="divider">
          <span>&</span>
        </div>

        <governorate-selection
          v-if="hasStepsToDisplay"
          v-model="selectedGovernorate"
          :empty-value="null"
          :invalid="hasErrors && !selectedGovernorate"
          @update:modelValue="clearGovernorateError"
        />
        <div v-if="hasErrors && !selectedGovernorate" class="error_text">
          {{ $_getTranslations.visitor_sign_up_msg_warning_governorate }}
        </div>
      </section>
      <avatar-selection-carousel
        v-if="hasStepsToDisplay"
        :invalid="hasErrors && avatarError"
        @avatar-selected="clearAvatarError"
      />
      <div v-if="hasErrors && avatarError" class="error_text">
        {{ $_getTranslations.visitor_sign_up_msg_warning_avatar}}
      </div>

      <section>

        <p>
          {{ $_getTranslations.visitor_sign_up_2_by_completing_you_agree }}
          <a
            :href="$_getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_terms_and_conditions_link')"
            class="text_links terms"
          >{{ $_getTranslations.visitor_sign_up_terms_and_condition }}</a>
        </p>

        <base-button
          :disabled="(hasErrors || waitForResponse)"
          container-class="finish"
          @button:click.prevent="checkButton"
        >{{ $_getTranslations.visitor_sign_up_2_submit_button_complete }}</base-button>

        <p>
          {{ $_getTranslations.visitor_sign_up_already_have_account }}
          <router-link
            :to="'login'"
            class="text_links login"
          >{{ $_getTranslations.visitor_sign_up_login }}
          </router-link>
        </p>

        <div class="disclaimer">
          {{ $_getTranslations.visitor_sign_up_2_disclaimer_text }}
        </div>
      </section>
    </form>
    <loading v-if="showLoadingModal"
             @close="showLoadingModal = false">
    </loading>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '../../../common/mixins/flow';
import IntegrationMixin from '../../../common/mixins/integration';
import loading from '../../../components/home/modals/Loading';
import {apiResponseTypeEnum} from '../../../constants/api';
import translationMixin from "../../../common/mixins/translation";
import BaseButton from "../../common/button/BaseButton";
import BaseDigitFormInput from "../../common/formInput/BaseDigitFormInput";
import AvatarSelectionCarousel from "../../common/carousel/AvatarSelectionCarousel";
import GovernorateSelection from "../../common/formInput/GovernorateSelection";
import ReadOnlyStepperHeader from "../../common/header/ReadOnlyStepperHeader";

export default {
  name: 'sign-up-2',
  components: {
    ReadOnlyStepperHeader,
    GovernorateSelection,
    loading,
    BaseButton,
    BaseDigitFormInput,
    AvatarSelectionCarousel
  },
  mixins: [
    IntegrationMixin,
    RegistrationFlowMixin,
    translationMixin
  ],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      avatarError: false,
      pinError: false,
      blacklistWords: [],
      waitForResponse: false,
      hasStepsToDisplay: false,
      rememberMe: true,
      selectedGovernorate: null,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3', 'visitor_sign_up_disclaimer_text4'],
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator;
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
    ]),
    hasSimplify() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName;
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.$_getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const responseEnum = response.data;
        if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
          this.$router.push('register2');
        } else {
          if (responseEnum === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (responseEnum === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (responseEnum === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (responseEnum === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (responseEnum === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (responseEnum === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((responseEnum === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (responseEnum === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (responseEnum === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      this.hasErrors = false;
      this.message = '';
      this.avatarError = false;
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
        this.pinError = true;
      } else {
        this.hasErrors = false;
        this.message = '';
        this.pinError = false;
      }
    },
    checkButton() {
      /* eslint-enable */
      if (this.hasStepsToDisplay) {
        if (!localStorage.getItem('Avatar')) {
          this.hasErrors = true;
          this.message = 'visitor_sign_up_msg_warning_avatar';
          this.avatarError = true ;
        }
        if (this.governorateLength > 0 && !this.selectedGovernorate ) {
          this.hasErrors = true;
          this.message = 'visitor_sign_up_msg_warning_governorate';
        }
      }

      if (!this.user.pin || this.user.pin.length < 4 || this.user.pin.length > 8) {
        this.hasErrors = true;
        this.message = 'visitor_sign_up_msg_warning_pin'; // Add a message for PIN
        this.pinError = true;
      }

      if (!this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        const userInfo = {
          pin: this.user.pin,
          rememberMe: this.rememberMe,
          governorate: this.selectedGovernorate
        };
        const alternateVerifyAction = this.getAlternateVerifyPinAction();
        if (alternateVerifyAction) {
          // Call it with userInfo
          alternateVerifyAction({ userInfo });
        } else {
          // Fall back to default action
          this.getNextRegistrationStep({ governorate: this.selectedGovernorate })();
        }
      }
    },
    clearAvatarError() {
      this.avatarError = false;
      this.hasErrors = this.pinError || (!this.selectedGovernorate && this.hasStepsToDisplay); // Recalculate errors
    },
    clearGovernorateError() {
      this.hasErrors = this.pinError || this.avatarError; // Only keep errors if they still exist
    }
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'integrationHeader',
      'availableIntegrations',
      'displayPrice',
      'maximumDigitsPinLength',
      'governorateLength',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue